var map = {
	"./_CoinSection.scss": [
		18522
	],
	"./_MyBalance.scss": [
		36205
	],
	"./_TermsOfUse.scss": [
		54893,
		893
	],
	"./_protocol.scss": [
		91669
	],
	"./my-balance": [
		15104
	],
	"./my-balance.jsx": [
		15104
	],
	"./protocol": [
		71013
	],
	"./protocol.jsx": [
		71013
	],
	"./reservecoin": [
		9139
	],
	"./reservecoin.jsx": [
		9139
	],
	"./stablecoin": [
		77300
	],
	"./stablecoin.jsx": [
		77300
	],
	"./terms-of-use": [
		51797
	],
	"./terms-of-use-default": [
		4745,
		745
	],
	"./terms-of-use-default.jsx": [
		4745,
		745
	],
	"./terms-of-use.jsx": [
		51797
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 13856;
module.exports = webpackAsyncContext;